import ReferentListModelBase from '../_generated/modelBases/referent-list-model-base';

export default class ReferentListModel extends ReferentListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
